import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Button } from 'core/components/button';
import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import { NotificationCard } from 'core/components/notification-card';
import useStyles from './confirm-delete-internal-document-modal.styles';

const ConfirmDeleteInternalDocumentModal = ({ fileName, onConfirm, onClose }) => {
  const classes = useStyles();
  const [deleting, setDeleting] = useState(false);

  const onRemove = async () => {
    setDeleting(true);
    try {
      await onConfirm();
    } finally {
      setDeleting(false);
    }
  };

  return (
    <BaseDialog className={classes.modal} onClose={onClose} open>
      <div className={classes.container}>
        <Label className={classes.mainLabel} type="green75Big">
          Are you sure you want to delete this document?
        </Label>
        <Label className={classes.fileName} type="subtitle1Regular">
          {fileName}
        </Label>
        <NotificationCard className={classes.warning} iconSize="icon16Bold" type="light">
          <Label type="body3">You will not be able to undo this action.</Label>
        </NotificationCard>
        <div className={classes.buttonContainer}>
          <Button
            className={classes.buttons}
            variant="contained"
            color="primary"
            onClick={onRemove}
            disabled={deleting}
          >
            {deleting ? 'Deleting...' : 'Yes, delete'}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={onClose}
            className={classes.buttons}
            disabled={deleting}
          >
            No, keep
          </Button>
        </div>
      </div>
    </BaseDialog>
  );
};

ConfirmDeleteInternalDocumentModal.propTypes = {
  fileName: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default observer(ConfirmDeleteInternalDocumentModal);
